module.exports = __webpack_public_path__ + "static/security-2dce7d826a32a81a7eac2321458cf770.png";